/* eslint-disable max-lines */
import React, { useEffect, useState } from 'react'
import StyleGuide from '@taglivros/oef_componentes/build/components/styleGuide'
import Button from '@taglivros/oef_componentes/build/components/button'
import Input from '@taglivros/oef_componentes/build/components/input'
import { navigateParaDestinoPosLogin } from '../../utils/rotas/navigate'
import styled from 'styled-components'
import ModalErro from '../../components/ModalErro/ModalErro'
import ModalAjudaLogin from '../../components/ModalAjudaLogin/ModalAjudaLogin'
import { useGlobal } from '../../contexts/GlobalContext'
import {
  AJUDA_LOGIN_BOOKSTER,
  CAMPOS_FORMULARIO_LOGIN,
  ROTA_ASSOCIA_SE,
  ROTA_ASSOCIA_SE_BOOKSTER,
  TEXTO_BOTAO_LOGIN,
  TITULO_PAGINA_LOGIN
} from './constantsLogin'
import { empty, isEmptyObject } from '../../utils/helpers/helpers'
import { REQUIRED_MESSAGE, URLS } from '../../constants'
import { RECAPTCHA_KEY } from '../../utils/recaptcha'
import InlineLoader from '../../components/InlineLoader/InlineLoader'

const WrapperLogin = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: calc(100vh - 85px);

  h1 {
    ${StyleGuide.boldFonte}
    font-size: 40px;
    margin-bottom: 20px;

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      font-size: 50px;
    }
  }

  .esqueci-senha {
    a {
    color: ${StyleGuide.cores.azul};
    cursor: pointer;
    font-size: 14px;
    overflow: hidden;
    padding-right: 10px;
    text-decoration: underline;
    }

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      width: 145px;
    }
  }

  form {
    margin: 0 auto;
    max-width: 280px;
    text-align: left;
    width: 100%;

    .form__row {
      margin-bottom: 25px;
    }

    @media (min-width: ${StyleGuide.mediaQuery.mobile}) {
      max-width: 450px;
    }
  }

  .botao-login {
    text-align: center;
  }

  button {
    margin-top: 30px;
    padding: 15px 40px;
    z-index: 0;

    @media (max-width: ${StyleGuide.mediaQuery.mobile}) {
      padding: 15px 0;
    }
  }

  p {
    font-size: 18px;
    text-align: center;
  }

  span {
    color: ${StyleGuide.cores.azul};
    font-weight: bold;
  }
`

const CaptchaContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 16px;
  border-radius: 4px;
  cursor: pointer;
  margin: 20px;
  align-items: center;
`

const WrapperLoading = styled.div`
  align-items: center;
  background: rgba(255,255,255,0.7);
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;

  > div {
    margin: 0;
  }
`

function isRedirectBookster( redirectTo ) {
  return ( redirectTo || '' ).split( '/' ).includes( URLS.BOOKSTER )
}

const Login = () => {
  const {
    erroLogin,
    fazLogin,
    isAssociadoLogado,
    setErroLogin,
    getRedirectToParameter,
    getCouponParameter,
  } = useGlobal()
  const [ loading, setLoading ] = useState( false )
  const [ erros, setErros ] = useState( {} )
  const [ sucessos, setSucessos ] = useState( {} )
  const [ state, setState ] = useState( {} )
  const [ camposObrigatoriosPreenchidos, setCamposObrigatoriosPreenchidos ] = useState( false )
  const [ mostraAjudaBookster, setMostraAjudaBookster ] = useState( () => isRedirectBookster( getRedirectToParameter() ) )
  const camposObrigatorios = Object.keys( CAMPOS_FORMULARIO_LOGIN ).filter( campo => CAMPOS_FORMULARIO_LOGIN[ campo ].obrigatorio )
  const { captcha, setCaptcha } = useGlobal()

  useEffect( () => {
    if ( !isEmptyObject( state ) ) {
      const hasPreenchimento = camposObrigatorios.reduce( ( acumulador, campoObrigatorio ) => {
        return !empty( state[ campoObrigatorio ] ) && empty( erros[ campoObrigatorio ] ) && acumulador
      }, true )
      setCamposObrigatoriosPreenchidos( hasPreenchimento )
    }
  }, [ state, captcha ] )

  useEffect( () => {
    const checkRecaptcha = () => {
      if ( window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render ) {
        renderRecaptcha()
      } else {
        setTimeout( checkRecaptcha, 100 )
      }
    }
    checkRecaptcha()
  }, [] )

  useEffect( () => {
    if ( isAssociadoLogado ) {
      const redirectTo = getRedirectToParameter()
      getCouponParameter()
      navigateParaDestinoPosLogin( redirectTo )
    }
  }, [ isAssociadoLogado ] )

  const validate = ( event, isOnSubmit=false ) => {
    const { name, value } = event.target
    let validacaoErros = {}

    if ( value === '' && !isOnSubmit ) {
      validacaoErros = {
        ...erros,
        [ name ]: REQUIRED_MESSAGE
      }
    } else if ( !camposObrigatoriosPreenchidos || isOnSubmit ) {
      const obrigatoriosNaoPreenchidos = camposObrigatorios.reduce( ( acumulador, obrigatorio ) => {
        if ( empty( state[ obrigatorio ] ) ) {
          return {
            ...acumulador,
            [ obrigatorio ]: REQUIRED_MESSAGE
          }
        }

        return acumulador
      }, {} )

      validacaoErros = { ...erros, ...obrigatoriosNaoPreenchidos }
    }

    if ( value && value.length > 0 && !isOnSubmit ) {
      Object.entries( CAMPOS_FORMULARIO_LOGIN ).forEach( campo => {
        const [ chave ] = campo

        if ( chave === name && CAMPOS_FORMULARIO_LOGIN[ chave ].validador ) {
          validacaoErros = { ...erros, [ chave ]: CAMPOS_FORMULARIO_LOGIN[ chave ].validador( value ) }
        }
      } )
    }

    setSucessos( {
      ...sucessos,
      [ name ]: empty( validacaoErros[ name ] ) && !empty( state[ name ] )
    } )

    setErros( validacaoErros )
  }

  const handleChange = event => {
    const { name, value } = event.target

    setErros( {
      ...erros,
      [ name ]: null
    } )

    setSucessos( {
      ...sucessos,
      [ name ]: null
    } )

    setState( {
      ...state,
      [ name ]: value
    } )
  }

  const handleBlur = event => {
    validate( event )
  }

  const handleSubmit = event => {
    event.preventDefault()
    validate( event, true )
    const { email, senha } = state
    if ( isEmptyObject( erros ) ) {
      setLoading( true )
      fazLogin( { 'password': senha, 'username': email }, setLoading )
    }
  }

  function renderRecaptcha() {
    try {
      const { grecaptcha } = window
      if ( !RECAPTCHA_KEY || RECAPTCHA_KEY === 'undefined' ) {
        console.error( 'RECAPTCHA_KEY não está configurada' )
        return
      }
      const captchaElement = document.getElementById( 'divCaptcha' )
      if ( !captchaElement ) {
        console.error( 'Elemento divCaptcha não encontrado' )
        return
      }
      grecaptcha.enterprise.render( 'divCaptcha', {
        'sitekey': `${RECAPTCHA_KEY}`,
        'callback': callbackRecaptcha,
      } )
    } catch ( error ) {
      console.error( 'Erro ao renderizar reCAPTCHA:', error )
    }
  }

  function callbackRecaptcha( captchaToken ) {
    setCaptcha( captchaToken )
  }

  if ( isAssociadoLogado ) {
    return null
  }

  const redirectToParam = getRedirectToParameter()
  const isFluxoBookster = isRedirectBookster( redirectToParam )
  const rotaAssociaSe = isFluxoBookster ? ROTA_ASSOCIA_SE_BOOKSTER : ROTA_ASSOCIA_SE
  const rotaEsqueciSenha = redirectToParam
    ? `${URLS.ESQUECI_MINHA_SENHA}?redirectTo=${encodeURIComponent( redirectToParam )}`
    : URLS.ESQUECI_MINHA_SENHA

  return (
    <WrapperLogin>
      { loading ? (
        <WrapperLoading>
          <InlineLoader />
        </WrapperLoading>
      ) : null }

      { isFluxoBookster && mostraAjudaBookster ? (
        <ModalAjudaLogin
          showModal
          texto={ AJUDA_LOGIN_BOOKSTER }
          toggleModal={ () => setMostraAjudaBookster( false ) }
        />
      ) : null }

      {erroLogin && !isEmptyObject( erroLogin ) ?
        <ModalErro
          descricao={ erroLogin.descricao }
          showModal={ !isEmptyObject( erroLogin ) }
          titulo={ erroLogin.titulo }
          toggleModal={ () => setErroLogin( null ) }
        /> : null}

      <h1>{TITULO_PAGINA_LOGIN}</h1>

      <form onSubmit={ handleSubmit }>
        {Object.entries( CAMPOS_FORMULARIO_LOGIN ).map( campo => {
          const [ chave, objeto ] = campo
          return (
            <div
              className="form__row"
              key={ chave }
            >
              <Input
                erro={ erros[ chave ] }
                isPassword={ objeto.isPassword }
                label={ objeto.label }
                maxLength={ objeto.maxLength }
                name={ chave }
                onBlur={ handleBlur }
                onChange={ handleChange }
                onKeyPress={ objeto.handleKeyPress }
                onPressEnter={ handleSubmit }
                sucesso={ sucessos[ chave ] }
                tipo={ objeto.tipoInput }
                value={ state[ chave ] }
              />
            </div>
          )
        } )}
        <div className="esqueci-senha">
          <a
            href={ rotaEsqueciSenha }
            rel="noopener noreferrer"
          >
            Primeiro acesso / Esqueci minha senha
          </a>
        </div>

        <CaptchaContainer>
          <div
            className="g-recaptcha"
            data-action="CHECKOUT"
            data-sitekey={ RECAPTCHA_KEY }
            id="divCaptcha"
          />
        </CaptchaContainer>

        <div className="botao-login">
          <Button
            disabled={ !camposObrigatoriosPreenchidos || captcha === null }
            testId="botao-login"
            type={ Button.TYPE_SUBMIT }
          >
            {TEXTO_BOTAO_LOGIN}
          </Button>
        </div>
      </form>
      <p>
        {'Ainda não possui uma assinatura? '}
        <a
          href={ rotaAssociaSe }
          rel="noopener noreferrer"
          target="_blank"
        >
          <span>Associe-se</span>
        </a>
      </p>
    </WrapperLogin>
  )
}

export default Login
